import TimeTable from './TimeTable';

export default TimeTable;
